module.exports = __webpack_public_path__ + "static/img/no-order.84fb2b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/no-order.png
// module id = 156
// module chunks = 116